import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function JoinTheMovement() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="40636" id="start-your-first-order" ref={ref} className="bg-primary text-accent-foreground relative w-full py-32 md:py-48 lg:py-64 overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute inset-0 z-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1611703/img/africa_from_space.png)] bg-cover bg-center bg-fixed opacity-10 mix-blend-overlay grayscale" aria-hidden="true" />

      {}
      <div className="absolute inset-0 z-10 bg-primary/20 mix-blend-multiply" />

      {}
      <div className={cn("relative z-20 container mx-auto px-4 text-center transition-all duration-1000 transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
        <h2 className="text-6xl md:text-8xl lg:text-9xl font-black tracking-tighter text-accent-foreground uppercase mb-12">
          Ready to save?
        </h2>

        <div className="flex justify-center">
          <Button asChild size="lg" className="bg-black text-white hover:bg-black/90 text-xl md:text-2xl px-12 py-10 h-auto rounded-none border-none shadow-2xl transition-transform hover:scale-105">
            <Link to="/DownloadPage">Download the App</Link>
          </Button>
        </div>
      </div>
    </section>;
}